var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',[_c('v-container',{staticClass:"m-0 p-0",attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('pre',{staticStyle:{"height":"100vh","margin-bottom":"0"}},[_vm._v(_vm._s(_vm.viewLog))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }